import classNames from "classnames";
import React from "react";

import css from "./card.module.scss";

type CardProps = {
  header?: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  privateBg?: boolean;
  qaId?: string;
  shadowType?: "none" | "pfOriginal" | "rx0" | "rx1" | "rx2" | "rx3";
  noPadding?: boolean;
  rootClassName?: string;
  bodyClassName?: string;
};

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      header,
      children,
      style = {},
      privateBg = false,
      qaId = "Card",
      shadowType = "rx0",
      noPadding = false,
      rootClassName,
      bodyClassName
    },
    ref
  ) => (
    <div
      ref={ref}
      data-qa-id={qaId}
      className={classNames(css.card, rootClassName, {
        [css.privateBg]: privateBg,
        [css.noPadding]: noPadding,
        [css.shadowPF]: shadowType === "pfOriginal",
        [css.shadowRx0]: shadowType === "rx0",
        [css.shadowRx1]: shadowType === "rx1",
        [css.shadowRx2]: shadowType === "rx2",
        [css.shadowRx3]: shadowType === "rx3",
        [css.none]: shadowType === "none"
      })}
      style={style}
    >
      {header}
      <div className={classNames(css.body, bodyClassName)}>{children}</div>
    </div>
  )
);

Card.displayName = "Card";

export default Card;
